"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const form_1 = require("../form");
let timeout;
const wait = (seconds) => new Promise(res => setTimeout(() => {
    res();
}, 1000 * seconds));
function useStatusHandler() {
    const dispatch = (0, react_redux_1.useDispatch)();
    return (state) => __awaiter(this, void 0, void 0, function* () {
        // add the pending status before other states
        if (state === 'PENDING') {
            dispatch((0, form_1.changeStatus)('PENDING'));
            timeout = wait(1);
            return;
        }
        if (timeout) {
            yield timeout;
            dispatch((0, form_1.changeStatus)(state));
        }
        else {
            dispatch((0, form_1.changeStatus)(state));
        }
        // if we are setting the status to success or error, wait 1000ms and then reset the status
        if (state === 'SUCCESS') {
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                if (timeout)
                    yield timeout;
                dispatch((0, form_1.changeStatus)('WAITING'));
            }), 1500);
        }
        if (state === 'ERROR') {
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                if (timeout) {
                    yield timeout;
                    yield wait(1);
                }
                dispatch((0, form_1.changeStatus)('CHANGED'));
            }), 1500);
        }
    });
}
exports.default = useStatusHandler;
